import { connect } from "react-redux";
import { requestGetTasksByClaimId } from "../../../../store/data/thunks";
import { State } from "../../../../store/state";

import Tasks from "./Tasks";

const mapStateToProps = (state: State) => ({
  customerId: state.authentication.user.customerId,
  tasks: state.data.tasks
});

const mapDispatchToProps = {
  requestGetTasksByClaimId
};

const TasksContainer = connect(mapStateToProps, mapDispatchToProps)(Tasks);

export default TasksContainer;
